import script from "./VotingModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./VotingModule.vue?vue&type=script&setup=true&lang=ts"

import "./VotingModule.vue?vue&type=style&index=0&id=5e23e1d4&lang=css"

const __exports__ = script;

export default __exports__